var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-footer',{staticStyle:{"padding-top":"20px"}},[_c('el-divider'),_c('h3',[_vm._v(" 操作记录：")]),_c('el-timeline',{staticClass:"opt-log"},_vm._l((_vm.divideLog),function(activity,index){return _c('el-timeline-item',{key:index,attrs:{"color":activity.color}},[_vm._v(" 【 "+_vm._s(`${activity.created_at}`)+"】 "+_vm._s(activity.msg)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }